import React from 'react';
import { Icon } from '@iconify-icon/react';

const record = [
  {
    year: '2023',
    icon: 'tabler:code',
    title: 'Samsung bans staff from consumer chatbots',
    body: 'After engineers pasted confidential source code into ChatGPT, Samsung barred generative AI tools on company devices — one of many enterprises to do so.',
  },
  {
    year: '2024',
    icon: 'tabler:scale',
    title: 'The American Bar Association weighs in',
    body: 'ABA Formal Opinion 512 put lawyers on notice: entering client information into generative AI tools without safeguards can violate the duty of confidentiality.',
  },
  {
    year: '2025',
    icon: 'tabler:toggle-right',
    title: 'Training-by-default becomes the norm',
    body: 'Major AI labs moved consumer accounts to data-sharing for model training by default, with multi-year retention — unless each user finds the toggle and opts out.',
  },
  {
    year: '2026',
    icon: 'tabler:folder-search',
    title: 'Courts order 20 million chats produced',
    body: 'In January 2026, a federal court in New York affirmed orders requiring a major AI provider to hand plaintiffs a sample of 20 million consumer chat logs in litigation.',
  },
  {
    year: '2026',
    icon: 'tabler:file-x',
    title: 'No privilege for consumer AI work',
    body: 'In February 2026, a federal judge ruled that documents generated with consumer AI tools were not protected by attorney–client privilege or the work-product doctrine.',
  },
];

const TheRecord: React.FC = () => (
  <section aria-label="Documented incidents" className="bg-white pb-20 sm:pb-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="relative overflow-hidden rounded-[28px] border border-gray-100 bg-gradient-to-b from-gray-50 to-white px-6 py-12 sm:px-12">
        <div className="max-w-2xl">
          <span className="text-[11px] font-semibold uppercase tracking-[0.24em] text-[#b8862e]">
            The record so far
          </span>
          <h2 className="mt-3 font-display text-3xl font-medium italic tracking-tight text-gray-900 sm:text-4xl">
            &ldquo;This isn&rsquo;t hypothetical.&rdquo;
          </h2>
          <p className="mt-4 text-base leading-relaxed text-gray-500">
            Regulators, courts, and employers have been drawing the same conclusion for three years:
            confidential work does not belong in consumer AI tools.
          </p>
        </div>

        <div className="mt-10">
          <ol className="relative space-y-8 border-l border-[#d3a641]/40 pl-8">
            {record.map((item, idx) => (
              <li key={`${item.year}-${idx}`} className="relative">
                <span className="absolute -left-[41px] flex h-[26px] w-[26px] items-center justify-center rounded-full border border-[#d3a641]/50 bg-white">
                  <span className="h-2 w-2 rounded-full bg-[#d3a641]" />
                </span>
                <div className="flex flex-col gap-1 sm:flex-row sm:items-baseline sm:gap-4">
                  <span className="font-display text-lg italic text-[#b8862e]">{item.year}</span>
                  <div className="flex-1">
                    <h3 className="flex items-center gap-2 text-base font-bold text-gray-900">
                      <Icon icon={item.icon} className="text-lg text-[#004790]" />
                      {item.title}
                    </h3>
                    <p className="mt-1 max-w-2xl text-sm leading-relaxed text-gray-500">
                      {item.body}
                    </p>
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </div>
  </section>
);

export default TheRecord;
